export const rmaFeeSelector = state => state.entities.rmaFees;
